import React, { createContext, useContext } from 'react';
import { OptionTypeEnum } from 'src/components/filter-dropdown';
import { EmptyProduct } from '../product-context';
import type { IPriceRowContext } from './price-row/types';
import { ViewSize } from './price-row/types';

const initialValue: IPriceRowContext = {
  offer: {
    featured: false,
    authorizedDealer: false,
    isInternationalPrice: false,
    ourChoiceScore: 0,
  },
  product: EmptyProduct,
  isFeatured: false,
  showUnfeaturedHideButton: false,
  setShowUnfeaturedPlaceholder: undefined,
  sorting: OptionTypeEnum.CHEAPEST_PRICE,
  viewSize: ViewSize.SMALL,
};
const PriceRowContext = createContext<IPriceRowContext>(initialValue);

export const usePriceRowContext = () => useContext(PriceRowContext);

export const PriceRowContextContainer: React.FC<
  React.PropsWithChildren<IPriceRowContext>
> = props => {
  return (
    <PriceRowContext.Provider value={props}>
      {props.children}
    </PriceRowContext.Provider>
  );
};
